const fileBlobs = new Map<string, File>();

export function rememberFileBlob(id: string, file: File): void {
  fileBlobs.set(id, file);
}

export function getFileBlob(id: string): File | undefined {
  return fileBlobs.get(id);
}

export function forgetFileBlob(ids: string[]): void {
  for (const id of ids) fileBlobs.delete(id);
}

export function forgetFileBlobs(): void {
  fileBlobs.clear();
}
